import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PageHeader } from "@ant-design/pro-components";
import {
  Layout,
  Breadcrumb,
  Row,
  Col,
  Form,
  Input,
  Button,
  Typography,
  notification,
  Select,
  Tag,
} from "antd";

/**
 * Actions
 */
import { allCategoriesObj, addObject } from "auth/actions/objActions";

/**
 * Components
 */
import TopBar from "components/NavBar/TopBar";
import DrawerSider from "components/NavBar/DrawerSider";
import { LayoutTopSide } from "components/NavBar/styles";
import { PageHeaderDecorator } from "assets/icons";
import { useSelector } from "react-redux";


const { Content } = Layout;
const { Paragraph } = Typography;
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

export default function NewForm() {
  const user = useSelector((state) => state.session.user);
  const { company } = useSelector(state => state.user);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [loadingSend, setLoadingSend] = useState(false);

  useEffect(() => {
    allCategoriesObj({
      companyId: company.companyId,
      unitId: company.unitId
    }).then((items) => {
      setCategories(items.message);
    });
  }, []);

  const routes = [
    {
      breadcrumbName: "Formulários",
      href: "/formularios/todos",
    },
    {
      breadcrumbName: "novo",
    },
  ];
  const content = (
    <Paragraph style={{ paddingBottom: "2rem" }}>
      Use formulários padrões ou personalizados para coletar dados e salvar em
      sua biblioteca.
    </Paragraph>
  );
  const ContentAlternative = ({ children, extraContent }) => (
    <Row>
      <div style={{ flex: 1 }}>{children}</div>
      <div className="image">{extraContent}</div>
    </Row>
  );

  const onCheckName = async () => {
    try {
      const values = await form.validateFields();
      console.log("Success:", values);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  /**
   * Adiciona novo formulário
   * @param {*} values
   */
  const onFinish = (values) => {
    if (loadingSend) return;
    setLoadingSend(true);

    addObject({
      formName: values.name.trim(),
      createdBy: user.sub,
      categories: values.categories,
      description: values.description,
      companyId: company.companyId,
      unitId: company.unitId
    })
      .then(async (response) => {
        if (response.success) {
          notification["success"]({
            message: "Sucesso",
            description: response.message
              ? response.message
              : "Algo está errado, tente novamente!",
          });
          await sleep(3000);
          window.location.href = "/formularios/todos";
        } else {
          notification["error"]({
            message: "Erro",
            description: response.message
              ? response.message
              : "Algo está errado, tente novamente!",
          });
          setLoadingSend(false);
        }
      })
      .catch((err) => {
        notification["error"]({
          message: "Erro",
          description: err.message
            ? err.message
            : "Algo está errado, tente novamente!",
        });
        setLoadingSend(false);
      });
  };


  const categoryRender = (props) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const item = categories.find((x) => x._id === value);

    return (
      <Tag
        color={
          item && item.color !== undefined
            ? item.color.hex
            : "#03A9F4"
        }
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3,
        }}
      >
        {label !== undefined ? label : "#03A9F4"}
      </Tag>
    );
  };

  return (
    (<Layout
      style={{
        height: "100vh",
      }}
    >
      <LayoutTopSide>
        <TopBar />
        <Layout>
          <DrawerSider />
          <Layout style={{ padding: "0 24px 24px", minHeight: "100vh" }}>
            <PageHeader
              className="site-page-header"
              style={{ margin: "16px 0 24px 0", background: "var(--cp-surface)" }}
              title="Novo formulário"
              onBack={() => window.history.back()}
              subTitle="Crie seus formulários personalizados."
              breadcrumb={
                <Breadcrumb>
                  {routes.map((a) =>
                    a.hasOwnProperty("href") ? (
                      <Breadcrumb.Item key={Math.random()}>
                        <a href onClick={() => navigate(a.href)}>
                          {a.breadcrumbName}
                        </a>
                      </Breadcrumb.Item>
                    ) : (
                      <Breadcrumb.Item>{a.breadcrumbName}</Breadcrumb.Item>
                    )
                  )}
                </Breadcrumb>
              }
            >
              <ContentAlternative extraContent={<PageHeaderDecorator alt="content" width="100%" />}>
                {content}
              </ContentAlternative>
            </PageHeader>

            <Content
              className="site-layout-background"
              style={{
                padding: 46,
                margin: 0,
                minHeight: 280,
                background: "var(--cp-surface)",
              }}
            >
              <Row gutter={16}>
                <Col xs={24} lg={16}>
                  <Form
                    {...formItemLayout}
                    form={form}
                    name="register"
                    onFinish={onFinish}
                    scrollToFirstError
                  >
                    <Form.Item
                      name="name"
                      label="Nome do formulário"
                      rules={[
                        {
                          required: true,
                          message:
                            "Por favor insira um nome para este formulário!",
                          whitespace: true,
                        },
                        {
                          message: "Este nome não é permitido!",
                          validator: (_, value) => {
                            const trimmedValue = value.trim() || "";
                            if (
                              trimmedValue === "user" ||
                              trimmedValue === "operation" ||
                              trimmedValue === "permission" ||
                              trimmedValue === "reports" ||
                              trimmedValue === "role" ||
                              trimmedValue === "session"
                            ) {
                              return Promise.reject();
                            } else {
                              return Promise.resolve();
                            }
                          },
                        },
                        {
                          validator: (_, value) => {
                            if (value && value.endsWith(" ")) {
                              return Promise.reject("O nome não deve terminar com um espaço!");
                            } else {
                              return Promise.resolve();
                            }
                          },
                        },
                        {
                          validator: (_, value) => {
                            const regex = /^[\p{L}\p{N} ]+$/u;
                            if (value && !regex.test(value)) {
                              return Promise.reject("Somente letras, números e espaços são permitidos!");
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name="categories"
                      label="Categorias"
                      placeholder="Escolha as categorias do formulário."
                    >
                      <Select
                        mode={"multiple"}
                        tagRender={categoryRender}
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                      >
                        {categories.map((category) => (
                          <Select.Option key={category._id} value={category._id}>{category.name}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="description"
                      label="Descrição"
                    >
                      <Input.TextArea rows={4} placeholder="Descrição do formulário" />
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                      <Button type="primary" htmlType="submit" loading={loadingSend}>
                        Adicionar formulário
                      </Button>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </Content>
          </Layout>
        </Layout>
      </LayoutTopSide>
    </Layout>)
  );
}
